import { Fragment } from "react"
import Skeleton from "react-loading-skeleton"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"
import UserDashboard from "./user/UserDashboard"

export default function Dashboard() {

    let user = useSelector(state => state.user.user)

    return <Fragment>
        {user ? user.is_admin ? <Navigate to='/admin' /> : <UserDashboard /> : <Skeleton count={50} />}
    </Fragment>
}